export default __webpack_public_path__ + "static/media/Pricing_Tiers.cd9aeca2.png";